import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { getProtectedResource } from "../../services/apiRequest.service";
import { NestedResponseData } from "../../models/responseData";
import {
  TransformedData,
  transformDataStackedByAnswer
} from "../../utils/transformDataUtils";
import FilterDropdown from "../../components/FilterDropdown";
import StackedByAnswer from "../../charts/stackedBarChart/stackedByAnswer";
import InstitutionN from "../../components/InstitutionN";
import PageLoader from "../../components/PageLoader";
import ApiResponseToCSVConverter from "../../utils/csvDownload/ApiResponseToCsvConverter";
import { determineResponseTypeNestedResponseData } from "../../utils/determineResponseType";


const SubSection7 = () => {
  const [selectedFilter, setSelectedFilter] = useState("exit_status");
  const [apiResponse, setApiResponse] = useState<NestedResponseData | null>(null);
  const [apiResponseStatistics, setApiResponseStatistics] = useState<NestedResponseData | null>(null);
  const [transformedResponse, setTransformedResponse] = useState<TransformedData[] | null>(null);
  const [institutionN, setInstitutionN] = useState(0);

  const { getAccessTokenSilently } = useAuth0();
  const { year } = useParams();

  useEffect(() => {
    const getResponseData = async () => {
      const accessToken = await getAccessTokenSilently();
      const requestUrl = `section6/subsection7/?report_year=${year}&group_by=${selectedFilter}&statistics=False`;
      const { data, error } = await getProtectedResource(accessToken, requestUrl);

      if (data && determineResponseTypeNestedResponseData(data)) {
        setApiResponse(data);
        setTransformedResponse(transformDataStackedByAnswer(data, "6.7", selectedFilter));
        setInstitutionN(data.institution.total.total);
      }

      if (error) {
        console.error("Error fetching data:", error);
      }
    };

    const getDataStatistics = async () => {
      const accessToken = await getAccessTokenSilently();
      const requestUrl = `section6/subsection7/?report_year=${year}&group_by=${selectedFilter}&statistics=True`;
      const { data, error } = await getProtectedResource(accessToken, requestUrl);

      if (data && determineResponseTypeNestedResponseData(data)) {
        setApiResponseStatistics(data);
      }

      if (error) {
        console.error("Error fetching data:", error);
      }
    };

    getResponseData();
    getDataStatistics();
  }, [getAccessTokenSilently, selectedFilter, year]);

  return (
    <>
      <h2>6.7 Your counteroffer: Extent to which it matched outside offer</h2>
      <p>
        To what extent did the compensation and resources provided in the counteroffer you received match your outside offer?
      </p>

      {!transformedResponse && <PageLoader />}

      {transformedResponse &&
        <>
          <InstitutionN institutionN={institutionN} />
          <FilterDropdown setSelectedFilter={setSelectedFilter} />
          <StackedByAnswer
            data={transformedResponse}
            section="6.7"
            sequential={true}
            institutionN={institutionN}
            selectedFilter={selectedFilter}
          />
          <ApiResponseToCSVConverter
            apiResponse={apiResponse}
            apiResponseB={apiResponseStatistics}
            selectedFilter={selectedFilter}
            filename="6.7_Your_counteroffer_Extent"
            section="6.7"
          />
        </>
      }

      
    </>
  )
}

export default SubSection7;